// 吃瓜今日 · 晨间瓜速递 — 静态内容数据（虚构内容，仅供页面展示）

export const siteMeta = {
  brand: '吃瓜今日',
  slogan: '晨间瓜速递 · 一早就到的瓜',
  edition: '第 2098 期',
  date: '2026年9月7日 星期一',
  updateTime: '今晨 06:30 已更新',
};

export interface NewsItem {
  id: string;
  time: string;
  tag: string;
  category: string;
  title: string;
  excerpt: string;
  heat: string;
  source: string;
  fresh?: boolean;
}

export const categories = [
  { key: '全部', icon: 'ri-fire-line' },
  { key: '影视瓜', icon: 'ri-movie-2-line' },
  { key: '综艺瓜', icon: 'ri-tv-line' },
  { key: '音乐瓜', icon: 'ri-music-2-line' },
  { key: '饭圈瓜', icon: 'ri-heart-3-line' },
  { key: '时尚瓜', icon: 'ri-shirt-line' },
  { key: '热点瓜', icon: 'ri-flashlight-line' },
];

export const briefing: NewsItem[] = [
  {
    id: 'n1',
    time: '06:32',
    tag: '首发',
    category: '影视瓜',
    title: '古装新剧《长安夜宴图》双主演官宣，片方称年底定档',
    excerpt: '开机仅两周便登顶待播剧期待榜，制作方透露该剧首次采用“长镜头夜宴实拍”，服化道耗时八个月复原盛唐风貌。',
    heat: '12.8万',
    source: '片方官宣',
    fresh: true,
  },
  {
    id: 'n2',
    time: '07:05',
    tag: '头条',
    category: '综艺瓜',
    title: '音综《星光补给站》第三季路透：导师飞行阵容引全网猜谜',
    excerpt: '录制地封闭场外被拍到三辆神秘保姆车进出，粉丝按车辆挂件细节层层解密，登上热搜前五的“豪华阵容”名单持续发酵。',
    heat: '9.6万',
    source: '现场路透',
    fresh: true,
  },
  {
    id: 'n3',
    time: '07:40',
    tag: '猛料',
    category: '饭圈瓜',
    title: '顶流舞台「夏栀」机场饭拍单日破纪录，应援打卡成新景点',
    excerpt: '一组连拍四小时不换机的出圈饭拍让“夏栀今天下班了吗”话题阅读量半天破亿，当地商圈已开始投放限定应援屏。',
    heat: '15.3万',
    source: '网友投稿',
    fresh: true,
  },
  {
    id: 'n4',
    time: '08:15',
    tag: '',
    category: '时尚瓜',
    title: '高奢品牌秋冬大秀首次移师国内，东方纹样成当晚关键词',
    excerpt: '本季系列以“江南光影”为概念，将旗袍立领与解构廓形结合，头排嘉宾与秀场装置双双刷屏，时尚板块讨论度飙升。',
    heat: '7.4万',
    source: '秀场报道',
  },
  {
    id: 'n5',
    time: '08:48',
    tag: '头条',
    category: '音乐瓜',
    title: '民谣乐队「老周与晚风」新专辑首周销量出炉，实体唱片反超数位',
    excerpt: '回归木质编曲与手写文案的复古企划意外走红，专辑同名曲连续三天占据日榜首位，实体版本一周内两次加印。',
    heat: '6.8万',
    source: '平台榜单',
  },
  {
    id: 'n6',
    time: '09:20',
    tag: '',
    category: '影视瓜',
    title: '悬疑剧《雾中来客》口碑逆袭，编剧直播拆解伏笔圈粉',
    excerpt: '开分后连续上涨近三成，主创开启“每日一答”互动，观众逐集复盘线索图，被戏称为“今年烧脑但友好”的追剧体验。',
    heat: '5.2万',
    source: '口碑追踪',
  },
  {
    id: 'n7',
    time: '09:52',
    tag: '首发',
    category: '热点瓜',
    title: '暑期档颁奖季预热：多部黑马剧组被曝“二轮点映”计划',
    excerpt: '业内消息称口碑领跑的多部中小成本影片将开启第二轮城市点映，档期与排片策略成为影迷讨论的新焦点。',
    heat: '8.1万',
    source: '行业动态',
  },
  {
    id: 'n8',
    time: '10:15',
    tag: '',
    category: '饭圈瓜',
    title: '应援物资回收倡议引共鸣：粉丝团体自发组织公益捐赠',
    excerpt: '多个头部粉丝站联合发起“灯牌不落地、心意不断电”活动，将演出物料二次回收捐赠给山区学校，评论区一片暖评。',
    heat: '4.9万',
    source: '粉丝站公告',
  },
];

export const hotList = [
  { rank: 1, title: '《星光补给站》第三季神秘导师是谁？', heat: '382万' },
  { rank: 2, title: '夏栀机场饭拍出圈，粉丝应援成打卡点', heat: '356万' },
  { rank: 3, title: '《长安夜宴图》官宣双主演定档年底', heat: '311万' },
  { rank: 4, title: '高奢秋冬大秀首移师国内，东方纹样刷屏', heat: '274万' },
  { rank: 5, title: '老周与晚风新专辑实体唱片反超数位', heat: '240万' },
  { rank: 6, title: '《雾中来客》编剧直播拆解伏笔', heat: '218万' },
  { rank: 7, title: '多部黑马影片被曝二轮点映计划', heat: '197万' },
  { rank: 8, title: '粉丝应援物料回收公益捐赠获点赞', heat: '163万' },
  { rank: 9, title: '年度最受期待电影名单发布', heat: '142万' },
  { rank: 10, title: '秋季档综艺片单抢先看', heat: '128万' },
];

export interface GalleryItem {
  id: string;
  title: string;
  note: string;
  img: string;
}

export const gallery: GalleryItem[] = [
  {
    id: 'g1',
    title: '秀场前排 · 光影之间',
    note: '高奢秋冬大秀开场装置',
    img: 'https://readdy.ai/api/search-image?query=editorial%20fashion%20runway%20backstage%20scene%20with%20warm%20amber%20studio%20lighting%2C%20flowing%20silk%20garments%20in%20coral%20and%20terracotta%20tones%2C%20elegant%20model%20silhouette%2C%20soft%20depth%20of%20field%2C%20cinematic%20magazine%20photography%2C%20warm%20ivory%20background%2C%20refined%20and%20stylish%20atmosphere&width=720&height=900&seq=gallery-01&orientation=portrait',
  },
  {
    id: 'g2',
    title: '夜宴长镜头 · 幕后',
    note: '《长安夜宴图》片场实拍装置',
    img: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20banquet%20film%20set%20at%20dusk%20with%20warm%20lanterns%20and%20candlelight%2C%20elegant%20traditional%20wooden%20architecture%2C%20flowing%20robes%20and%20stage%20light%2C%20cinematic%20teal%20and%20amber%20color%20grade%2C%20movie%20behind%20the%20scenes%20photography%2C%20detailed%20and%20atmospheric&width=720&height=900&seq=gallery-02&orientation=portrait',
  },
  {
    id: 'g3',
    title: '机场接机 · 灯牌海',
    note: '夏栀应援现场实录',
    img: 'https://readdy.ai/api/search-image?query=crowd%20of%20enthusiastic%20fans%20holding%20glowing%20light%20sticks%20and%20banners%20at%20night%20airport%20arrival%20hall%2C%20warm%20coral%20and%20amber%20neon%20glow%2C%20cinematic%20shallow%20depth%2C%20energetic%20yet%20warm%20documentary%20style%20photography%2C%20dark%20soft%20background%20with%20vivid%20highlights&width=720&height=900&seq=gallery-03&orientation=portrait',
  },
  {
    id: 'g4',
    title: '返场舞台 · 星光补给',
    note: '音综录制舞台灯光',
    img: 'https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20spotlights%20and%20haze%2C%20silhouette%20of%20a%20singer%20with%20microphone%20on%20elegant%20music%20show%20set%2C%20amber%20and%20peach%20colored%20stage%20lighting%2C%20energetic%20atmosphere%2C%20cinematic%20live%20performance%20photography%2C%20clean%20minimal%20framing&width=720&height=900&seq=gallery-04&orientation=portrait',
  },
];

export interface FeatureArticle {
  id: string;
  category: string;
  title: string;
  lead: string;
  body: string;
  author: string;
  readTime: string;
  img: string;
  hot?: boolean;
}

export const features: FeatureArticle[] = [
  {
    id: 'f1',
    category: '深度解析',
    title: '为什么古装实拍剧，越来越能让观众“追下去”？',
    lead: '从服化道复原到长镜头调度，一场“回归片场”的行业回潮正在发生。',
    body: '当观众厌倦了悬浮抠图，越来越多的剧组选择把预算花在看得见的细节上：实景搭棚、同期收音、按文物比例复原的器物。这份“笨功夫”带来的沉浸感，正在重新定义什么叫好剧的标准。',
    author: '早报编辑部',
    readTime: '5 分钟',
    hot: true,
    img: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20set%20being%20constructed%20with%20artisans%20and%20craftsmen%20in%20warm%20afternoon%20light%2C%20traditional%20architecture%20woodwork%20and%20silk%20banners%2C%20documentary%20filmmaking%20behind%20the%20scenes%2C%20cinematic%20warm%20amber%20and%20ivory%20tones%2C%20detailed%20editorial%20photography%20atmosphere&width=900&height=600&seq=feature-01&orientation=landscape',
  },
  {
    id: 'f2',
    category: '瓜田观察',
    title: '应援文化进化论：从灯牌海洋到公益亮灯',
    lead: '当粉丝把爱意写进城市广告牌与乡村书桌，追星也悄悄换了表达。',
    body: '应援早已不只是买票打榜。从机场灯牌到公益助学，新一代粉丝正把“为偶像做点什么”升维成“为社会做点什么”，这种双向奔赴也被越来越多的路人转发点赞。',
    author: '瓜田研究员',
    readTime: '4 分钟',
    img: 'https://readdy.ai/api/search-image?query=fans%20volunteering%20to%20pack%20books%20and%20school%20supplies%20for%20donation%20boxes%20in%20bright%20community%20hall%2C%20warm%20daylight%20through%20windows%2C%20warm%20cream%20and%20coral%20accents%2C%20sincere%20documentary%20reportage%20photography%2C%20people%20helping%20together%2C%20clean%20bright%20atmosphere&width=900&height=600&seq=feature-02&orientation=landscape',
  },
  {
    id: 'f3',
    category: '行业前瞻',
    title: '高奢大秀南下：东方审美正在成为全球时尚新叙事',
    lead: '把T台搬进江南园林，这一季的“中国时刻”比想象中更彻底。',
    body: '当立领、盘扣与水墨遇上解构主义，东方元素不再只是点缀。头部品牌把首发秀场设在东方语境里，背后是消费市场与审美话语权的双重迁移。',
    author: '时尚线记者',
    readTime: '6 分钟',
    img: 'https://readdy.ai/api/search-image?query=fashion%20runway%20show%20inside%20classical%20chinese%20garden%20at%20golden%20hour%2C%20models%20in%20modern%20oriental%20tailored%20silhouettes%20walking%20on%20stone%20bridge%2C%20warm%20amber%20sunlight%20and%20soft%20mist%2C%20editorial%20luxury%20fashion%20photography%2C%20cinematic%20warm%20tones%20elegant%20composition&width=900&height=600&seq=feature-03&orientation=landscape',
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '吃瓜今日早报是什么？',
    a: '吃瓜今日早报是一份每个工作日清晨更新的娱乐资讯速递，把当天最值得关注的影视、综艺、音乐、饭圈与时尚热点整理成几分钟就能读完的“晨间瓜速递”，帮你在通勤路上快速掌握今日头条瓜。',
  },
  {
    q: '每天几点更新？首发的“猛料”可靠吗？',
    a: '早报通常在清晨 6 点至 7 点之间上线，节假日调整为午间增刊。对于标注“首发”与“猛料”的内容，我们坚持对信源进行交叉核实，并与多家正规媒体来源保持一致，绝不采用来源不明的单方爆料。',
  },
  {
    q: '如何向你们提供爆料或投稿线索？',
    a: '如果你有经得起核实的瓜或现场线索，可通过页面底部联系邮箱与我们沟通，投稿前请附上可验证的时间、地点与信源说明。对采用的高价值线索，我们会主动与你对接后续。',
  },
  {
    q: '早报订阅收费吗？如何退订？',
    a: '每日早报完全免费，订阅后可定时在邮箱收到当天速递。订阅邮件底部均设有退订入口，点击一次即可取消，我们不会保留与发送无关的邮箱使用记录。',
  },
  {
    q: '报道中是否会侵犯明星与当事人的隐私？',
    a: '我们只报道已经进入公共视野的影视作品、公开活动与行业动态，不对私人行程与未公开隐私进行臆测或传播，内容遵循“可公开、可核实、可转载”的三可原则。',
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  avatarText: string;
}

export const testimonials: Testimonial[] = [
  {
    name: '阿梨不熬夜',
    role: '通勤打工人 · 订阅 180 天',
    text: '每天地铁上六分钟就把早瓜吃完，从没迟到过办公室热点。省下翻五个软件的时间，还能跟同事聊上首发瓜。',
    avatarText: '梨',
  },
  {
    name: '追星观察员',
    role: '娱乐行业编辑',
    text: '最难得是每一条都写了信源和核实情况，做内容的人看得到这种克制。转载引用也规范，是我日常的选题参考。',
    avatarText: '观',
  },
  {
    name: '周末电影人',
    role: '影视爱好者',
    text: '早报的深度解析不猎奇，分析得挺扎实。《雾中来客》那篇直接帮我理清了追剧线索，已经安利给全宿舍。',
    avatarText: '影',
  },
];

export const stats = [
  { value: '2098', label: '累计已发行期数' },
  { value: '360W+', label: '日均阅读人次' },
  { value: '68%', label: '早报完读率' },
  { value: '7min', label: '平均阅读时长' },
];